module.exports = __webpack_public_path__ + "img/fTL.f00246d6.png";